import { PreLoaderStylesProvider } from "./styles/PreLoaderStylesProvider"

export const PreLoader = () => {
    return(
        <>
            <PreLoaderStylesProvider>
                <div></div>
            </PreLoaderStylesProvider>
        </>
    )
}
